import { useMemo } from 'react';
import { useTripPositionsAnalysisStore } from '../../stores/analysis/useTripPositionsAnalysisStore';
import { getTripKey } from '../../utils/tripAnalysis';

export function useTripPositionsAnalysis(date, codigo) {

    const key = useMemo(() => {

        if (!date || !codigo) {
            return null;
        }

        return getTripKey(
            date,
            codigo
        );

    }, [date, codigo]);

    return useTripPositionsAnalysisStore(
        state => {

            if (!key) {
                return null;
            }

            return (
                state.positionsMap.get(key) ||
                null
            );
        }
    );

}